export default function Logistics({ data }) {
  return (
    <div>
      <h2 className="text-yellow-200 mb-3">Logistics</h2>

      {data?.logistics?.map((l, i) => (
        <div key={i} className="bg-gray-800 p-2 mb-2 rounded">
          {l.lotId} → {l.status} ({l.vehicle})
        </div>
      ))}
    </div>
  );
}